import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from './../../../actions';
import template from './ImportFeatures.rt';
import PropTypes from 'prop-types';
import FeatureImporter from '../../../utilities/featureImporter';
import * as IFActions from './ImportFeaturesActions';
import fabricator from '../../../reducers/fabricator';

export const WARNING_TYPES = {
  None: 0,
  Backup: 1,
  Save: 2
}

const MapStateToProps = (state) => {
  const { auth, asCustomer } = state;
  return {
    auth,
    asCustomer
  };
}

const MapDispatchToProps = (dispatch, props) => {
  return {
    showLoadingDialog: (show, title, text) => dispatch(actions.loadingDialog_show(show, title, text)),
    showMessageBox: (show, title, message, buttons) => dispatch(actions.messageBox_Show(show, "system", title, message, buttons)),
    showErrorBox: (show, title, message) => dispatch(actions.messageBox_Show(show, "error", title, message))
  };
}

class ImportFeaturesClass extends PureComponent {
  constructor(props) {
    super(props)
    this.ImportFeatures = new FeatureImporter();
    this.state = {
      hasRecords: false,
      isVisible: false,
      pending: false,
      validationData: null,
      nextVisible: false,
      backupVisible: false,
      nextEnabled: false,
      clearEmpty: false,
      assignRelatedBoxes: false,
      createCopies: false,
      warningVisible: false,
      warningType: WARNING_TYPES.None,
      exportDialogVisible: false,
      backupCategoriesOnly: false,
      backupWizardOnly: false,
      backupKitchen: true,
      backupBathroom: true,
      backupFireplace: true,
      backupLaundryroom: true,
      backupFilters: false,
      visualizerOnly: false, 
      quotingToolOnly: false,
      masterFabricatorId: null
    };
  }
  setDropzoneRef = (ref) => {
    if (ref && ref.node) {
      this.dropzoneNode = ref.node;
    }
  }
  setDropZoneState = (accept, callback) => {
    if (this.dropzoneNode) {
      this.dropzoneNode.style.boxShadow = '0 0 1em ' + (accept ? 'green' : 'red') + ' inset';
      window.setTimeout(() => {
        this.dropzoneNode.style.boxShadow = '';
        callback && callback();
      }, accept ? 1000 : 4000);
    }
  }

  setMasterFabricatorId = (e) => {
    this.setState({ ...this.state, masterFabricatorId: e.target.value });
  }
  onDrop = (file) => {
    this.props.showLoadingDialog(true, "Loading Data...", "Scanning/Loading data, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        if (file && file.length === 1) {
          if (_.endsWith(_.trim(file[0].name.toLowerCase()), ".csv")) {
            this.setDropZoneState(true, () => {
              this.setState({ pending: true });
              var reader = new FileReader();
              reader.readAsText(file[0], "UTF-8");
              reader.onload = (evt) => {
                let csvString = evt.target.result;
                this.ImportFeatures.setCSVString(csvString)
                  .then(() => this.ImportFeatures.validateData())
                  .then((r) => {
                    this.setState({
                      validationData: { ...r },
                      pending: false,
                      nextVisible: true,
                      nextEnabled: r.complete && _.isEmpty(r.errors)
                    });

                    this.validateRows();
                  });
              }
              reader.onerror = (evt) => {
                console.log('error reading file');
              }
              this.props.showLoadingDialog(false);
            });
          } else {
            this.setDropZoneState(false);
          }
        } else {
          this.setDropZoneState(false);
          console.log('file did not exist', file);
        }
        this.setState({ pending: false });
      });
  }

  next = () => {
    let { clearEmpty, warningVisible } = this.state;
    if (warningVisible) {
      this.save();
    } else {
      this.setState({ warningVisible: true, warningType: clearEmpty ? WARNING_TYPES.Backup : WARNING_TYPES.Save, nextVisible: !clearEmpty, backupVisible: clearEmpty });
    }
  }

  save = () => {
    var fabId = (this.props.asCustomer && this.props.asCustomer.data && this.props.asCustomer.data.customerId) || this.props.auth.fabricatorId;
    this.props.showLoadingDialog(true, "Importing", "Importing Features, please be patient this may take some time...");
    IFActions.importFeatures({
      fabricatorId: fabId,
      masterFabricatorId: this.state.masterFabricatorId,
      importFeatures: this.ImportFeatures.getData(),
      assignRelatedBoxes: this.state.assignRelatedBoxes,
      createCopies: this.state.createCopies,
    }).then(r => {
      this.props.showLoadingDialog(false);
      if (r.Success) {
        this.props.showMessageBox(true, "Success", "Import completely successfully.", [{
          text: 'OK',
          onClick: () => {
            this.props.showMessageBox(false);
            this.setState({ isVisible: false, warningVisible: false, warningType: WARNING_TYPES.None });
          }
        }]);
      } else {
        this.props.showErrorBox(true, "Failed", r.Error);
      }
    });
  }

  show = (e) => {
    if (e && e.target && e.target.closest(".ui-popup--overlay")) { // template's onClick={this.show} is triggering each time we click something in popup
      return false
    }
    this.setState({
      hasRecords: false,
      isVisible: true,
      pending: false,
      validationData: null,
      nextVisible: false,
      backupVisible: false,
      nextEnabled: false,
      clearEmpty: false,
      assignRelatedBoxes: false,
      createCopies: false,
      warningVisible: false,
      warningType: WARNING_TYPES.None,
      exportDialogVisible: false,
      backupCategoriesOnly: false,
      backupWizardOnly: false,
      backupFilters: false,
      backupKitchen: true,
      backupBathroom: true
    });
  }

  showExport = () => {
    this.setState({
      exportDialogVisible: true,
      nextVisible: false,
      backupVisible: true,
      backupEnabled: this.state.backupKitchen || this.state.backupBathroom || this.state.backupFireplace || this.state.backupLaundryroom
    });
  }

  backup = () => {
    let fabricatorId = this.props.asCustomer.data ? this.props.asCustomer.data.fabricatorId : this.props.auth.fabricatorId;
    IFActions.getFeatures(fabricatorId, this.state.backupCategoriesOnly, this.state.backupWizardOnly, this.state.backupKitchen, this.state.backupBathroom, this.state.backupFireplace, this.state.backupLaundryroom, this.state.visualizerOnly, this.state.quotingToolOnly, this.state.backupFilters)
      .then((response) => {
        var resJson = JSON.parse(response);
        var blob = new Blob([resJson.data], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, resJson.filename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", resJson.filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      });
    this.show();
    return true;
  }

  validateRows = () => {
    const rows = this.ImportFeatures.getData();
    if (!rows) return;

    let isValidManufacturers = true;
    let isValidProductName = true;

    rows.forEach(row => {
      if (!row["ProductName"]) {
        isValidProductName = false;
      }

      const featGroup = row["FeatureGroup"].toLowerCase();
      const featureGroups = featGroup.split(',');
      if (featureGroups.includes("countertop") || featureGroups.includes("backsplash") || featureGroups.includes("center island countertop")) {
        if (!row["Manufacturer"]) {
          isValidManufacturers = false;
        }
      }
    });

    if (!isValidProductName || !isValidManufacturers) {
      let errorMessage = "";
      if (!isValidProductName)
        errorMessage += "All features must have 'ProductName' filled. <br/>";
      if (!isValidManufacturers)
        errorMessage += "Some of your countertops are missing manufacturer filters. <br/>";

      errorMessage += "<br/>Please complete these and retry."

      this.props.showErrorBox(true, "CSV Validation Failed", errorMessage);
      this.setState({
        hasRecords: false,
        isVisible: true,
        pending: false,
        validationData: null,
        nextVisible: false,
        backupVisible: false,
        nextEnabled: false,
        clearEmpty: false,
        assignRelatedBoxes: false,
        createCopies: false,
        warningVisible: false,
        warningType: WARNING_TYPES.None,
        exportDialogVisible: false,
        backupCategoriesOnly: false,
        backupWizardOnly: false,
        backupFilters: false,
        backupKitchen: true,
        backupBathroom: true,
        backupFireplace: true,
        backupLaundryroom: true,
        visualizerOnly: false, 
        quotingToolOnly: false,
      });
    }
  }

  render = template;
}

ImportFeaturesClass.propTypes = {
};

const connector = connect(MapStateToProps, MapDispatchToProps);
const ImportFeatures = connector(ImportFeaturesClass);

export { ImportFeatures };
export default ImportFeatures;

